module.exports = __webpack_public_path__ + "img/WeChamberGraphs.72705a50.png";